import { useEffect, useMemo, useState } from 'react';
import { Badge, Button } from 'react-bootstrap';
// import { AiOutlineDelete } from 'react-icons/ai';
import { FaEye, FaPlus, FaRegEdit, FaUser, FaUserSlash } from 'react-icons/fa';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
  useAsyncDebounce,
  useExpanded,
  useFilters,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable
} from 'react-table';
import { toast } from 'react-toastify';
// import Swal from 'sweetalert2';
import DefaultColumnFilter from '../../../../Components/ReactTable/Filters/DefaultColumnFilter';
import ReactTableRender from '../../../../Components/ReactTable/ReactTableRender';
import ToolTip from '../../../../Components/ToolTip';
import UserImage from '../../../../Components/UserImage';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';
import { useRef } from 'react';
import { toNepaliNumber } from '../../../../_helpers/_methods';
import { checkPermission } from '../../../../_helpers/roles/check-roles';
import { promoteUser } from '../../../../Redux/slices/user';
import { useDispatch } from 'react-redux';
function TraineesList() {
  const dispatch = useDispatch();
  const intl = useIntl();
  const navigate = useNavigate();
  const local = useSelector((state) => state.local.local);
  const permissions = useSelector((state) => state.user.permissions);
  const user = useSelector((state) => state.user.user);

  const [URL, setURL] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [nameSearch, setNameSearch] = useState('');
  const [phoneSearch, setPhoneSearch] = useState('');
  const [filteredTrainee, setFilteredTrainee] = useState([]);

  const gotoPage = (page) => setPageNum(page);
  const previousPage = (page) => setPageNum(page);
  const nextPage = (page) => setPageNum(page);

  const handleParticipantEdit = (id) => {
    navigate({ pathname: `/admin/trainees/${id}/edit` });
  };
  const handleSuspend = async (id) => {
    try {
      await fetchWrapper.get(`/profile/participant/${id}/suspend/`);
      toast.success(<FormattedMessage id="suspended_successfully" />);
      fetchtrainees();
      navigate('/admin/users/trainees/list');
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };
  const handleUnSuspend = async (id) => {
    try {
      await fetchWrapper.get(`/profile/participant/${id}/unsuspend/`);
      toast.success(<FormattedMessage id="unsuspended_successfully" />);
      fetchtrainees();
      navigate('/admin/users/trainees/list');
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  const ManualFilterByName = ({ column: { filterValue, setFilter } }) => {
    const inputRef = useRef(null);
    const [name, setName] = useState(filterValue);
    const handleNameChange = useAsyncDebounce((value) => {
      setFilter(value || undefined);
      setNameSearch(value);
    }, 800);
    return (
      <input
        ref={inputRef}
        value={name || ''}
        onChange={(e) => {
          setName(e.target.value);
          handleNameChange(e.target.value);
        }}
        placeholder={intl.formatMessage({ id: 'filter.search' })}
      />
    );
  };

  const ManualFilterByPhone = ({ column: { filterValue, setFilter } }) => {
    const inputRef = useRef(null);
    const [phone, setPhone] = useState(filterValue);
    const handlePhoneChange = useAsyncDebounce((phone) => {
      setFilter(phone || undefined);
      setPhoneSearch(phone);
    }, 800);
    return (
      <input
        ref={inputRef}
        type="number"
        value={phone || ''}
        onChange={(e) => {
          setPhone(e.target.value);
          handlePhoneChange(e.target.value);
        }}
        placeholder={intl.formatMessage({ id: 'filter.search' })}
      />
    );
  };

  const SelectColumnFilter = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = useMemo(() => {
      const options = new Set();
      preFilteredRows.forEach((row) => {
        options.add(row.values[id]);
      });
      return [...options.values()];
    }, [id, preFilteredRows]);

    // Render a multi-select box
    return (
      <select
        value={filterValue}
        onChange={(e) => {
          setFilter(e.target.value || undefined);
        }}>
        <FormattedMessage id="tableSelect.all">
          {(label) => <option value="">{label[0]}</option>}
        </FormattedMessage>
        {options.map((option, i) => (
          <option key={i} value={option}>
            {option}
          </option>
        ))}
      </select>
    );
  };
  const handleUserPromotion = (user, promotionRole) => {
    const userData = {
      fullname: user.fullname,
      email: user.email,
      phone: user.phone,
      user: user.user
    };
    dispatch(promoteUser(userData));
    navigate(`/admin/users/${promotionRole}s/new?promotion=${promotionRole}`);
  };
  const columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="sn" />,
        accessor: 'serial_number',
        width: '80px',
        disableFilters: true
      },
      {
        Header: <FormattedMessage id="userFullName" />,
        accessor: 'fullname',
        Filter: ManualFilterByName,
        Cell: ({ row: { original }, cell: { value } }) => {
          return (
            <Link to={`/admin/users/trainees/profile/${original.id}`}>
              <span className="d-flex align-items-center ">
                <div className="me-1 position-relative">
                  <UserImage
                    avatar={original.image}
                    userName={value}
                    userId={String(original.id)}
                  />
                  <span className="avatar-profile-iscomplete-badge">
                    {original.warnings && (
                      <ToolTip
                        warnings={original.warnings}
                        isComplete={original.is_profile_updated}
                      />
                    )}
                  </span>
                </div>

                <span className="d-block">
                  {value} <br />
                </span>
                {original.isSuspend && (
                  <Badge bg="danger" className="ms-2">
                    Suspended
                  </Badge>
                )}
              </span>
            </Link>
          );
        }
      },
      {
        Header: <FormattedMessage id="mobile_number" />,
        Filter: ManualFilterByPhone,
        accessor: 'mobile_number'
      },

      {
        Header: <FormattedMessage id="address" />,
        accessor: 'address'
      },

      {
        Header: <FormattedMessage id="gender" />,
        accessor: 'gender',
        Filter: SelectColumnFilter,
        filter: 'equals'
      },
      {
        Header: <FormattedMessage id="caste/group" />,
        accessor: 'caste_group'
      },
      {
        Header: <FormattedMessage id="participant_type" />,
        accessor: 'office_type',
        Filter: SelectColumnFilter
      },
      {
        Header: <FormattedMessage id="office_name" />,
        accessor: 'office_name'
      },
      {
        Header: <FormattedMessage id="actions" />,
        accessor: 'actions',
        disableFilters: true,
        Cell: ({ row: { original } }) => {
          let promotionOptions = [];
          let hasExecutiveProfile = false;
          let hasCdAdminProfile = false;
          let roleArray = original.role;
          if (typeof roleArray === 'string') {
            roleArray = [roleArray];
          }
          roleArray?.forEach((role) => {
            if (role.key === 'executive') {
              hasExecutiveProfile = true;
            } else if (role.key === 'cd_admin') {
              hasCdAdminProfile = true;
            }
          });

          if (!hasExecutiveProfile) {
            promotionOptions.push('executive');
          }
          if (!hasCdAdminProfile) {
            promotionOptions.push('cd_admin');
          }
          console.log(promotionOptions, 'promotionOptions');
          const hasPromotionOptions = promotionOptions.length > 0;
          return (
            <div>
              <div className="d-flex">
                <div>
                  <Link to={`/admin/users/trainees/profile/${original.id}`}>
                    <Button className="action-button" variant="outline-primary">
                      <FaEye />
                    </Button>
                  </Link>
                </div>
                {permissions['Can change participant'] && (
                  <>
                    <div className="ms-2">
                      <Button
                        variant="outline-success "
                        onClick={() => handleParticipantEdit(original.id)}>
                        <FaRegEdit />
                      </Button>
                    </div>
                    <div className="ms-2 ">
                      {original.isSuspend ? (
                        <Button
                          className="d-flex justify-content-center align-items-center "
                          style={{ minWidth: '130px' }}
                          variant="outline-secondary "
                          onClick={() => handleUnSuspend(original.id)}>
                          <FaUser className="me-2" />
                          <FormattedMessage id="unsuspend" />
                        </Button>
                      ) : (
                        <Button
                          className="d-flex justify-content-center align-items-center "
                          style={{ minWidth: '165px' }}
                          variant="outline-danger "
                          onClick={() => handleSuspend(original.id)}>
                          <FaUserSlash className="me-2" />
                          <FormattedMessage id="suspend" />
                        </Button>
                      )}
                    </div>
                  </>
                )}
              </div>{' '}
              <div>
                {checkPermission(user.active_role, 'Can promote') && hasPromotionOptions && (
                  <div className="d-flex flex-column">
                    {promotionOptions.map((option) => (
                      <Button
                        variant={option === 'executive' ? 'outline-danger' : 'outline-primary'}
                        className="mt-2"
                        key={option}
                        onClick={() => handleUserPromotion(original, option)}>
                        <FormattedMessage id={`promote-${option}`} />
                      </Button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          );
        }
      }
    ],
    [filteredTrainee, permissions, local]
  );

  const data = useMemo(() => {
    if (Array.isArray(filteredTrainee)) {
      let count = (pageNum - 1) * 50 + 1;

      return filteredTrainee.map((result) => {
        return {
          serial_number: local === 'ne' ? toNepaliNumber(count++) : count++,
          fullname: result.fullname,
          mobile_number: result.phone,
          email: result.email,
          phone: result.phone,
          user: result.user,
          role: result.role,
          address: result.address,
          office_name: result.office_name,
          gender: intl.formatMessage({ id: result.gender || 'p' }),
          office_type: result.employee_type_title?.join(', '),
          caste_group: result.ethenicity?.title,
          image: result?.image,
          muncipality: result.office_address,
          id: result.id,
          isSuspend: result.suspended,
          warnings: result.warnings,
          is_profile_updated: result.is_profile_updated
        };
      });
    } else {
      return [];
    }
  }, [filteredTrainee]);

  const defaultColumn = useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter
    }),
    []
  );

  const { headerGroups, getTableProps, getTableBodyProps, page, prepareRow, visibleColumns } =
    useTable(
      {
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: 50 },
        manualPagination: true,
        defaultCanFilter: false,
        defaultColumn
      },
      useFilters,
      useSortBy,
      useExpanded,
      usePagination,
      useRowSelect
    );

  const paramsGenerator = () => {
    let params = '';
    if (pageSize) {
      params += `&limit=${pageSize}`;
    }
    if (pageNum) {
      params += `&offset=${(pageNum - 1) * pageSize}&page=${pageNum}`;
    }
    if (nameSearch) {
      params += `&fullname=${nameSearch}`;
    }
    if (phoneSearch) {
      params += `&phone=${phoneSearch}`;
    }
    return params;
  };
  useEffect(() => {
    let url = '/profile/participant/?approved=true&active_role=participant';

    let params = paramsGenerator();
    setURL(`${url}${params}`);
  }, [pageSize, pageNum, nameSearch, phoneSearch]);

  const fetchtrainees = async () => {
    try {
      setLoading(true);
      const response = await fetchWrapper.get(URL);
      setTotalCount(response.data.count);
      setFilteredTrainee(response.data.results);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      ErrorMessageHandler(error);
    }
  };
  useEffect(() => {
    if (URL) fetchtrainees();
  }, [URL]);

  const pageCountArray = useMemo(
    () => Array.from({ length: Math.ceil(totalCount / pageSize) }, (v, i) => i + 1),
    [totalCount, pageSize]
  );

  return (
    <div>
      <div className="card-header">
        <h3 className="text-primary d-flex justify-content-between">
          <FormattedMessage id="participants" />

          {permissions['Can add participant'] && (
            <Link className="btn btn-success me-2" to="/admin/users/trainees">
              <FaPlus />
              <span className="ms-2"></span>

              <FormattedMessage id="add_new" />
            </Link>
          )}
        </h3>
      </div>
      <ReactTableRender
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        getTableBodyProps={getTableBodyProps}
        page={page}
        prepareRow={prepareRow}
        totalCount={totalCount}
        gotoPage={gotoPage}
        previousPage={previousPage}
        pageCount={pageCountArray?.length}
        pagination={true}
        pageCountArray={pageCountArray}
        pageNum={pageNum}
        showGoto={true}
        nextPage={nextPage}
        canNextPage={pageNum < pageCountArray?.length}
        canPreviousPage={pageNum > 1}
        loading={loading}
        visibleColumns={visibleColumns}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
}

export default TraineesList;
